import { Container, ContainerBodyProps, useIsContainerCollapsed } from '@chronosphereio/chrono-ui';

export interface VizContainerBodyBaseProps extends ContainerBodyProps {}

/**
 * Component that contains content to be rendered within a `VizContainer`.
 *
 * It extends from the chrono-ui `Container.Body` component and shares similar props and behavior, when possible,
 * for consistency.
 *
 * This is the "base" version of the component that comes with very minimal features. Instead use `Body` if you want a
 * more feature-rich root component.
 */
export const VizContainerBodyBase = ({ children, ...containerProps }: VizContainerBodyBaseProps) => {
  const collapsed = useIsContainerCollapsed();

  // We do not render the children when the panel is collapsed because the combination of the underlying
  // responsive autosizers and the parent MUI collapse play poorly together and lead to a weird UX where
  // you see it shrink rapidly with a teeny chart inside trying to handle the resize. A long-term fix for
  // this is likely tricky and time-consuming. so for now, we stop rendering the chart on collapse, which
  // has a less jarring UX.
  const renderChildren = !collapsed;

  return <Container.Body {...containerProps}>{renderChildren ? children : null}</Container.Body>;
};
